(() => {
  const MOBILE = window.matchMedia('(max-width: 749px)');
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  let raf = null;
  let track = null;
  let x = 0;
  let loopWidth = 0;
  let paused = false;
  let resizeTimer = null;

  function getTrack(){
    track = document.querySelector('.aureko-confidence-bar__inner');
    return track;
  }

  function cancel(){
    if(raf) cancelAnimationFrame(raf);
    raf = null;
  }

  function removeClones(){
    if(!track) return;
    track.querySelectorAll('[data-aureko-marquee-clone="true"]').forEach((node) => node.remove());
    delete track.dataset.aurekoMarquee;
    track.style.transform = '';
    x = 0;
    loopWidth = 0;
  }

  function prepareTrack(){
    if(!getTrack()) return false;

    if(!MOBILE.matches || REDUCE.matches){
      removeClones();
      return false;
    }

    if(track.dataset.aurekoMarquee !== 'ready'){
      track.querySelectorAll('[data-aureko-marquee-clone="true"]').forEach((node) => node.remove());
      const originals = Array.from(track.children);
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.dataset.aurekoMarqueeClone = 'true';
        clone.setAttribute('aria-hidden','true');
        if(clone.matches('a')) clone.tabIndex = -1;
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach((el) => el.tabIndex = -1);
        track.appendChild(clone);
      });
      track.dataset.aurekoMarquee = 'ready';
    }
    return true;
  }

  function measure(){
    if(!track) return;
    const originals = Array.from(track.children).filter((el) => el.dataset.aurekoMarqueeClone !== 'true');
    loopWidth = originals.reduce((sum,el) => sum + el.getBoundingClientRect().width,0);
    x = Math.min(x,Math.max(0,loopWidth - 1));
  }

  function tick(){
    if(!track || !MOBILE.matches || REDUCE.matches) return;
    if(!paused && loopWidth > 0){
      x += 0.34;
      if(x >= loopWidth) x -= loopWidth;
      track.style.transform = `translate3d(${-x}px,0,0)`;
    }
    raf = requestAnimationFrame(tick);
  }

  function start(){
    cancel();
    getTrack();
    if(!track) return;

    if(!MOBILE.matches || REDUCE.matches){
      removeClones();
      return;
    }

    if(!prepareTrack()) return;
    measure();
    tick();
  }

  function bindPause(){
    const bar = document.querySelector('.aureko-confidence-bar');
    if(!bar || bar.dataset.aurekoMarqueeEvents === 'ready') return;
    bar.dataset.aurekoMarqueeEvents = 'ready';
    bar.addEventListener('pointerenter',() => { paused = true; });
    bar.addEventListener('pointerleave',() => { paused = false; });
    bar.addEventListener('focusin',() => { paused = true; });
    bar.addEventListener('focusout',() => { paused = false; });
    bar.addEventListener('touchstart',() => { paused = true; },{passive:true});
    bar.addEventListener('touchend',() => {
      window.setTimeout(() => { paused = false; },650);
    },{passive:true});
  }

  function init(){
    bindPause();
    start();
  }

  window.addEventListener('resize',() => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(start,180);
  },{passive:true});

  if(MOBILE.addEventListener) MOBILE.addEventListener('change',start);
  if(REDUCE.addEventListener) REDUCE.addEventListener('change',start);

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
